export default "__VITE_ASSET__$1PYy1fp__"